import React, { Fragment } from 'react';
import { Login as LoginFunc, Register, GetCode, GetFindPassWord } from '../common/ApiHelper';
import { BaseComponent, InputComponent as Input } from '../components/Index';

class Login extends BaseComponent {
    public charWidthRegister = '4em';
    public charWidthLogin = '3em';
    state = {
        TabIndex: 0,
        phone: '',
        password: '',
        confirmPassword: '',
        verificationCode: '',
        authCode: '',
        vCodeBtnName: '获取验证码'
    }
    TabOnClick = (Index: number) => {
        this.setState({TabIndex: Index});
    }
    public OnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.currentTarget;
        const _state = this.state
        let state: Partial<typeof _state> = {};
        switch (name) {
            case 'phoneRegister':
            case 'phoneLogin':
                state = { phone: value }
            break;
            case 'pwdRegister':
            case 'pwdLogin':
                state = { password: value }
            break;
            case 'vcodeRegister':
                state = { verificationCode: value }
            break;
            case 'acodeRegister':
                state = { authCode: value }
            break;
            case 'cpwdRegister':
                state = { confirmPassword: value }
            break;
        }
        this.setState(state);
    }
    public OnClickLogin = () => {
        const { phone, password } = this.state;
        console.log(phone, password);
        this.ShowToast('登录中....', 0);
        LoginFunc(phone, password, (res)=>{
            this.RemoveToast();
            if (res.ResultCode === 1) {
                this.ShowToast(res.Msg, 1, 2000);
            }
            localStorage.setItem('userID', res.Data.userInfo.userID.toString());
            window.userID = res.Data.userInfo.userID;
            let rd = this.GetQueryString(this.props.location.search,'rd');
            rd = rd === null ? '/' : rd;
            console.log(rd);
            this.props.history.push(rd);
        });
    }
    public OnClickRegister = () => {
        const { phone, password, confirmPassword, verificationCode, authCode } = this.state;
        const ShowTime = 1000;
        if (phone.length <= 0) {
            this.ShowToast('手机号不能为空', 1, ShowTime);
            return;
        }
        if (verificationCode.length <= 0) {
            this.ShowToast('验证码不能为空', 1, ShowTime);
            return;
        }
        if (authCode.length <= 0) {
            this.ShowToast('授权码不能为空', 1, ShowTime);
            return;
        }
        if (password.length <= 0) {
            this.ShowToast('密码不能为空', 1, ShowTime);
            return
        }
        if (confirmPassword.length <= 0){
            this.ShowToast('确认密码不能为空', 1, ShowTime);
            return;
        }
        if (confirmPassword.length > 0 && confirmPassword.length < 6){
            this.ShowToast('密码长度需大于等于6位', 1, ShowTime);
            return;
        }
        if (password !== confirmPassword) {
            this.ShowToast('确认密码不一致', 1, ShowTime);
            return;
        }

        Register(phone, verificationCode, authCode, password, (res)=>{
            console.log(res);
            if (res.ResultCode === 1) {

            }
            this.ShowToast(res.Msg, 1, 2000);
        });
    }
    public OnClickFindPWD = () => {
        const { phone, password, confirmPassword, verificationCode } = this.state;
        const ShowTime = 1000;
        if (phone.length <= 0) {
            this.ShowToast('手机号不能为空', 1, ShowTime);
            return;
        }
        if (verificationCode.length <= 0) {
            this.ShowToast('验证码不能为空', 1, ShowTime);
            return;
        }
        if (password.length <= 0) {
            this.ShowToast('密码不能为空', 1, ShowTime);
            return
        }
        if (confirmPassword.length <= 0){
            this.ShowToast('确认密码不能为空', 1, ShowTime);
            return;
        }
        if (confirmPassword.length > 0 && confirmPassword.length < 6){
            this.ShowToast('密码长度需大于等于6位', 1, ShowTime);
            return;
        }
        if (password !== confirmPassword) {
            this.ShowToast('确认密码不一致', 1, ShowTime);
            return;
        }
        GetFindPassWord(phone, verificationCode, password, (res)=>{
            this.ShowToast(res.Msg, 1, ShowTime);
        })
    }
    public TimeToatl = 30;
    public Time = 30;
    public Interval: any;
    public onVertificationCodeClick = (type: number) => {
        const { phone } = this.state;
        if (this.checkPhone(phone) === false) {
            this.ShowToast('手机号码有误，请重填', 1, 3000);
            return;
        }
        this.setState({vCodeBtnName: '获取验证码' + '(' + this.Time + ')'});
        this.Interval = setInterval(()=>{
            this.Time--;
            this.setState({vCodeBtnName: '获取验证码' + '(' + this.Time + ')'});
            if (this.Time === 0) {
                this.InitCode();
            }
        }, 1000);
        GetCode(phone, type, (res)=>{
            console.log(res);
            this.ShowToast(res.Msg, 1, 2000);
            if (res.ResultCode === 1) {
                this.InitCode();
            }
        })
    }
    public InitCode = () => {
        clearInterval(this.Interval);
        this.Time = this.TimeToatl;
        this.Interval = undefined;
        this.setState({vCodeBtnName: '获取验证码'});
    }
    checkPhone = (phone: string) => { 
        if(!(/^1[34578]\d{9}$/.test(phone))){ 
            return false; 
        }
    }
    public render() {
        const { charWidthRegister, charWidthLogin, OnChange, OnClickLogin, OnClickRegister, onVertificationCodeClick, OnClickFindPWD } = this;
        const { TabIndex, phone, password, confirmPassword, verificationCode, authCode, vCodeBtnName } = this.state;
        let BodyContent;
        switch (TabIndex) {
            case 0: //登录
                BodyContent = <Fragment>
                    <Input name='phoneLogin' key='phoneLogin' title='手机号' placeholder='请输入手机号' width={charWidthLogin} type='number' value={phone} maxLength={11} onChange={OnChange}/>
                    <Input name='pwdLogin' key='pwdLogin' title='密码' type='password' placeholder='请输入密码' width={charWidthLogin} value={password} maxLength={20} onChange={OnChange}/>
                    <span className='btn' onClick={OnClickLogin}>登 录</span>
                </Fragment>
            break;
            case 1: //注册
                BodyContent = <Fragment>
                    <Input name='phoneRegister' key='phoneRegister' title='手机号' placeholder='请输入手机号' width={charWidthRegister} type='number' value={phone} maxLength={11} onChange={OnChange}/>
                    <Input name='vcodeRegister' key='vcodeRegister' title='验证码' placeholder='请输入验证码' btnName={vCodeBtnName} btnOnClick={onVertificationCodeClick.bind(this, 0)} width={charWidthRegister} value={verificationCode} onChange={OnChange}/>
                    <Input name='acodeRegister' key='acodeRegister' title='授权码' placeholder='请输入授权码' width={charWidthRegister} value={authCode} onChange={OnChange}/>
                    <Input name='pwdRegister' key='pwdRegister' title='密码' placeholder='请输入6-20位字母或数字' width={charWidthRegister} type='password' maxLength={20} value={password} onChange={OnChange}/>
                    <Input name='cpwdRegister' key='cpwdRegister' title='确认密码' placeholder='再次确认密码' width={charWidthRegister} type='password' value={confirmPassword} onChange={OnChange}/>
                    <span className='btn' onClick={OnClickRegister}>立 即 注 册</span>
                </Fragment>
            break;
            case 2: //修改密码
                BodyContent = <Fragment>
                    <Input name='phoneRegister' key='phoneRegister' title='手机号' placeholder='请输入手机号' width={charWidthRegister} type='number' value={phone} maxLength={11} onChange={OnChange}/>
                    <Input name='vcodeRegister' key='vcodeRegister' title='验证码' placeholder='请输入验证码' btnName={vCodeBtnName} btnOnClick={onVertificationCodeClick.bind(this, 2)} width={charWidthRegister} value={verificationCode} onChange={OnChange}/>
                    <Input name='pwdRegister' key='pwdRegister' title='密码' placeholder='请输入6-20位字母或数字' width={charWidthRegister} type='password' maxLength={20} value={password} onChange={OnChange}/>
                    <Input name='cpwdRegister' key='cpwdRegister' title='确认密码' placeholder='再次确认密码' width={charWidthRegister} type='password' value={confirmPassword} onChange={OnChange}/>
                    <span className='btn' onClick={OnClickFindPWD}>提 交</span>
                </Fragment>
            break;
        }
        return <div className="c-box">
            <div className="c-banner1"><img src={require("../img/banner1.jpg")} /></div>
            <div className="c-index-menu">
                <div className='login'>
                    <div className='head'>
                        <span onClick={this.TabOnClick.bind(this, 0)} className={TabIndex === 0 ? 'on' : ''}>登录</span>
                        <span onClick={this.TabOnClick.bind(this, 1)} className={TabIndex === 1 ? 'on' : ''}>注册</span>
                        <span onClick={this.TabOnClick.bind(this, 2)} className={TabIndex === 2 ? 'on' : ''}>忘记密码</span>
                    </div>
                    <div className='body'>
                        {BodyContent}
                    </div>
                </div>
            </div>
        </div>
    }
}

export default Login;